import React, { useState, useEffect } from "react";
import { FaFileWord, FaFileCsv, FaFilePdf } from "react-icons/fa";
import { MdClose } from "react-icons/md";

const DragAndDropDocument = ({ onImagesUpdate, handleMediaDelete, uploadedImages, accept = "image/*", showPic = 3 }) => {
  const [images, setImages] = useState([]);
  const [visibleImages, setVisibleImages] = useState([]);
  const [imageIndex, setImageIndex] = useState(showPic);
  const [zoomedImage, setZoomedImage] = useState(null);

  // Sort and initialize images
  useEffect(() => {
    const sortedImages = [...uploadedImages].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    setImages(sortedImages);
    setVisibleImages(sortedImages.slice(0, showPic));
  }, [uploadedImages, showPic]);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addImages(e.dataTransfer.files);
  };

  const handleFileChange = (e) => {
    addImages(e.target.files);
  };

  const addImages = (files) => {
    if (!files.length) return;

    const allowedExtensions = accept.split(",").map((ext) => ext.trim().toLowerCase());
    const newImages = [];
    const errors = [];

    Array.from(files).forEach((file) => {
      const isAllowed = allowedExtensions.some((ext) => file.name.toLowerCase().endsWith(ext));

      if (!isAllowed) {
        errors.push(`"${file.name}" is not an allowed file type.`);
      } else if (!images.some((img) => img.file?.name === file.name)) {
        newImages.push({
          file,
          preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
          name: file.name,
          url: null,
          created_at: new Date().toISOString(),
        });
      }
    });

    if (errors.length) {
      alert(errors.join("\n"));
      return;
    }

    if (newImages.length > 0) {
      const updatedImages = [...newImages, ...images]
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      setImages(updatedImages);
      setVisibleImages(updatedImages.slice(0, imageIndex));
      onImagesUpdate?.(updatedImages);
    }
  };

  const removeImage = (index) => {
    const imageToDelete = visibleImages[index];

    if (imageToDelete.id) {
      handleMediaDelete(imageToDelete.id);
    } else {
      const updatedImages = images.filter((_, i) => i !== index);
      setImages(updatedImages);
      setVisibleImages(updatedImages.slice(0, imageIndex));
      onImagesUpdate?.(updatedImages);
    }
  };

  const handleViewMore = () => {
    const nextIndex = imageIndex + showPic;
    setImageIndex(nextIndex);
    setVisibleImages(images.slice(0, nextIndex));
  };

  const handleViewLess = () => {
    setImageIndex(showPic);
    setVisibleImages(images.slice(0, showPic));
  };

  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    if (ext === "docx") return <FaFileWord className="text-blue-500 text-6xl" />;
    if (ext === "csv") return <FaFileCsv className="text-green-500 text-6xl" />;
    if (ext === "pdf") return <FaFilePdf className="text-red-500 text-6xl" />;
    return null;
  };

  return (
    <div onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
      <div className="">
        {/* {visibleImages.map((image, index) => (
          <div key={index} className="relative bg-white rounded-lg overflow-hidden h-[222px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px' }}>
            <button
              className="absolute top-2 flex justify-center items-center right-2 bg-red-500 text-white rounded-full p-1 text-sm h-[16px] w-[16px]"
              onClick={() => removeImage(index)}
            >
              <MdClose />
            </button>

            {image.preview || (image.url && /\.(png|jpe?g|webp|gif)$/i.test(image.url)) ? (
              <img
                src={image.preview || image.url}
                alt={`preview-${index}`}
                className="w-full object-fill cursor-pointer h-full"
                onClick={() => setZoomedImage(image.preview || image.url)}
              />
            ) : (
              <>
                <div className="flex flex-col items-center p-4 bg-gray-200 rounded-lg">
                  {getFileIcon(image.name)}
                </div>
                <div className="flex flex-col items-center p-4 rounded-lg">
                  <p className="text-gray-700">{image.name}</p>
                  <a
                    href={image.url}
                    download={image.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 text-blue-500 underline cursor-pointer"
                  >
                    Download
                  </a>
                </div>
              </>
            )}
          </div>
        ))} */}
        {/* Drag and Drop Area */}
      <div className="">
        <input
          type="file"
          accept={accept}
          multiple
          onChange={handleFileChange}
          className="hidden"
          id="fileInput"
        />
        <label htmlFor="fileInput" className="cursor-pointer bg-secondary text-primary px-4 py-2 rounded-md mt-2">
          Browse Files
        </label>
      </div>
      </div>

      {/* View More / View Less Button */}
      {/* {images.length > showPic && (
        <div className="mt-4 flex justify-end">
          {imageIndex < images.length ? (
            <button
              onClick={handleViewMore}
              className="text-blue-500 underline cursor-pointer"
            >
              View More
            </button>
          ) : (
            <button
              onClick={handleViewLess}
              className="text-red-500 underline cursor-pointer"
            >
              View Less
            </button>
          )}
        </div>
      )} */}

      {/* Zoomed Image Preview */}
      {/* {zoomedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={() => setZoomedImage(null)}>
          <img src={zoomedImage} alt="Zoomed" className="max-w-full max-h-full" />
        </div>
      )} */}
    </div>
  );
};

export default DragAndDropDocument;
